var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Lotação ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Local de Lotação*",
      "counter": "100",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 100);
      }]
    },
    model: {
      value: _vm.content.local,
      callback: function ($$v) {
        _vm.$set(_vm.content, "local", $$v);
      },
      expression: "content.local"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('span', [_vm._v("O local de lotação é uma escola ou creche?*")]), _c('v-radio-group', {
    attrs: {
      "hide-details": "",
      "row": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }]
    },
    model: {
      value: _vm.content.ehEscola,
      callback: function ($$v) {
        _vm.$set(_vm.content, "ehEscola", $$v);
      },
      expression: "content.ehEscola"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.content.ehEscola ? _c('v-text-field', {
    directives: [{
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "counter": "10",
      "maxlength": "10",
      "label": "Código da Escola*",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$requiredIfTrue(v, _vm.content.ehEscola);
      }, function (v) {
        return _vm.$max(v, 10);
      }]
    },
    model: {
      value: _vm.content.codigo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "codigo", $$v);
      },
      expression: "content.codigo"
    }
  }) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('sca-gre-cidade', {
    attrs: {
      "required": ""
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios")])], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }